import { tv } from '~/utils/tv'

export const SwitchLabelVariants = tv({
  base: `
  text-text-neutral-alternative text-threepulse font-bold font-rdmodern line leading-medium text-nowrap
  `,
  variants: {
    isDisabled: {
      true: 'text-text-neutral-disabled',
    },
  },
})
